import theme from '@/theme'
import { IconButton, InputAdornment, OutlinedInput, OutlinedInputProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { navigate } from 'gatsby-link'
import React, { useState } from 'react'
import styled from 'styled-components'
import DefaultButton, { AccentButton } from '../Button'
import EyeIcon from '../Icon/svg/EyeIcon'
import EyeSlashIcon from '../Icon/svg/EyeSlashIcon'

namespace AuthFlow {
    export const Grid = styled.div`
        display: inline-grid;
        grid-template-columns: 1fr;
        row-gap: 25px;
        align-items: center;
        width: 100%;
        margin-top: 20px;
    `

    export const FlexCenter = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
    `

    export const ErrorsList = styled.ul`
        padding-left: 0;
        margin-left: 0;
        color: ${theme.colors.errorN};
    `

    export const ButtonsWrapper = styled(AuthFlow.FlexCenter)`
        margin-top: 20px;
        column-gap: 20px;

        > button {
            font-size: 14px;
            font-weight: bold;
        }
    `

    export const Cancel = () => <DefaultButton onClick={() => navigate('/')}>キャンセル</DefaultButton>

    export const Submit = (props: { children: React.ReactNode }) => (
        <AccentButton type="submit">{props.children}</AccentButton>
    )

    // =============================================================================================
    // Material UI
    // =============================================================================================

    const useFormStyles = makeStyles({
        root: {
            width: '100%',
            borderRadius: 5,
            backgroundColor: theme.colors.white,
            '&:hover': {
                backgroundColor: theme.colors.white,
            },
        },
        input: {
            padding: '10px 15px',
            '&::placeholder': {
                fontWeight: 400,
                fontSize: 16,
                color: theme.colors.placeholder,
                fontFamily: theme.typography.fontFamily,
            },
        },
    })

    export const FormField = (props: OutlinedInputProps) => {
        const { root, input } = useFormStyles()

        return <OutlinedInput classes={{ input }} className={`${root}`} type="text" fullWidth required {...props} />
    }

    export const PasswordField = (props: OutlinedInputProps) => {
        const [showPassword, setShowPassword] = useState(false)
        const toggleShowPassword = () => setShowPassword(!showPassword)

        return (
            <FormField
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                        </IconButton>
                    </InputAdornment>
                }
                {...props}
            />
        )
    }
}

export default AuthFlow
